function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M18 18H2c-.553 0-2-1.448-2-2V4c0-.552 1.447-2 2-2h2v2H2v12h16V4h-2V2h2c.552 0 2 1.448 2 2v12c0 .552-1.448 2-2 2zm-5-7h1.999v2H13v-2zm0-4h1.999v2H13V7zm0-7h1.999v4H13V0zm-2 13H9v-2h2v2zM9 7h2v2H9V7zM7.999 2h4v2h-4V2zM5 11h2v2H5v-2zm0-4h2v2H5V7zm0-7h2v4H5V0z"
});

var SvgCalendar = function SvgCalendar(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIxOCIgdmlld0JveD0iMCAwIDIwIDE4Ij4KICAgIDxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTggMThIMmMtLjU1MyAwLTItMS40NDgtMi0yVjRjMC0uNTUyIDEuNDQ3LTIgMi0yaDJ2MkgydjEyaDE2VjRoLTJWMmgyYy41NTIgMCAyIDEuNDQ4IDIgMnYxMmMwIC41NTItMS40NDggMi0yIDJ6bS01LTdoMS45OTl2MkgxM3YtMnptMC00aDEuOTk5djJIMTNWN3ptMC03aDEuOTk5djRIMTNWMHptLTIgMTNIOXYtMmgydjJ6TTkgN2gydjJIOVY3ek03Ljk5OSAyaDR2MmgtNFYyek01IDExaDJ2Mkg1di0yem0wLTRoMnYySDVWN3ptMC03aDJ2NEg1VjB6Ii8+Cjwvc3ZnPgo=";
export { SvgCalendar as ReactComponent };